define('core/utils/views',[
    'underscore',
], function (
    _
) {
    'use strict';

    /*
     * Basic implementation of mixin pattern. Copies all the properties/events from
     * mixin object to current view. In addition mixin customization is available through
     * mixinConfig (this is useful to split mixin configuration from view configuration).
     * All conflicting properties/events will be untouched in original view except initialize method,
     * which will be chained with mixin.initialize.
     *
     * Example of usage:
     *
     * utils.mixin(ViewClass, LocalScroll, {
     *      mixinProp: 'myconfig'
     * });
     */
    var mixer = function (viewClass, mixin, mixinConfig) {
        var proto = viewClass.prototype;
        var extendedMixin = _.extend({}, mixin, mixinConfig);
        _.defaults(proto, extendedMixin);
        _.defaults(proto.events, extendedMixin.events);
        if (proto.initialize !== undefined && extendedMixin.initialize !== undefined) {
            var originalInit = proto.initialize;
            proto.initialize = function () {
                var value = originalInit.apply(this, arguments);
                extendedMixin.initialize.apply(this, arguments);
                return value;
            };
        }
    };

    return {
        mixin: mixer,
    };
});

